import React, { FC } from 'react';
import { ThemeMode } from '@rbx/ui';
import { studioLogoSvg } from '../constants/studioResources';

interface StudioLogoProps {
  size: number;
  style?: Record<string, string | number>;
  themeMode: ThemeMode;
}

const StudioLogo: FC<React.PropsWithChildren<StudioLogoProps>> = ({ size, style, themeMode }) => {
  return (
    <img
      style={{
        ...(style ?? {}),
        width: size,
        height: size,
      }}
      alt='Roblox Studio Logo'
      src={studioLogoSvg[themeMode]}
    />
  );
};

export default StudioLogo;
